export default __webpack_public_path__ + "static/marisa-c5b4b9cd89a5e252071d28aef04b8a37.jpg";